import { ILibraryTopology } from '@wix/thunderbolt-components-registry'

export interface IComponentsRegistrySiteConfig {
	librariesTopology: Array<ILibraryTopology>
}

export const name = 'componentsRegistry'
